import { LoadingState, LoadingStates, Sentiment } from 'globals/types';
import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import {
  ReasonCode,
  ReasonCodeProps,
} from 'models/reusable-parts/reason-codes';
import { BarGraph, BarGraphProps } from 'models/reusable-parts/bar-graph';

export interface FinancialCredibilityProps {
  band: string;
  barGraph: BarGraphProps;
  reasonCodes: ReasonCodeProps[];
  status: LoadingState;
}

export const FinancialCredibility = types
  .model({
    band: types.maybe(types.string),
    barGraph: types.maybe(BarGraph),
    reasonCodes: types.optional(types.array(ReasonCode), []),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: FinancialCredibilityProps): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        ...props,
      };
      applySnapshot(self, newSnapshot);
    },
    updateStatus(status: LoadingState): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        status,
      };
      applySnapshot(self, newSnapshot);
    },
  }))
  .views((self) => ({
    pros(): string[] {
      const { reasonCodes } = self;
      return reasonCodes
        .filter(({ sentiment }) => sentiment === Sentiment.POSITIVE)
        .map(({ translation }) => translation);
    },
    cons(): string[] {
      const { reasonCodes } = self;
      return reasonCodes
        .filter(({ sentiment }) => sentiment === Sentiment.NEGATIVE)
        .map(({ translation }) => translation);
    },
  }));

export type FinancialCredibilitySnapshot = SnapshotIn<
  typeof FinancialCredibility
>;
export type FinancialCredibilityInstance = Instance<
  typeof FinancialCredibility
>;
